/**
 * Wizard-level types. Form field types match backend schemas:
 * - business-forms.js
 * - individual-forms.js
 * - forms-enums.js
 */

export const FORM_FILING_TYPE = {
  INDIVIDUAL: "INDIVIDUAL",
  BUSINESS: "BUSINESS",
} as const;

export type FormFilingType = (typeof FORM_FILING_TYPE)[keyof typeof FORM_FILING_TYPE];

export const BUSINESS_TYPE = {
  SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
  SINGLE_MEMBER_LLC: "SINGLE_MEMBER_LLC",
  PARTNERSHIP: "PARTNERSHIP",
  S_CORP: "S_CORP",
  C_CORP: "C_CORP",
} as const;

export const TAXPAYER_ID_TYPE = {
  SSN: "SSN",
  EIN: "EIN",
} as const;

export const ACCOUNTING_METHOD = {
  CASH: "CASH",
  ACCRUAL: "ACCRUAL",
} as const;

export const MILEAGE_METHOD = {
  STANDARD: "STANDARD",
  ACTUAL: "ACTUAL",
} as const;

/** US state codes for dropdowns (from backend US_STATE_CODES). */
export const US_STATE_CODES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
  "DC",
] as const;

export type USStateCode = (typeof US_STATE_CODES)[number];
